import { gql } from 'apollo-angular';

export const getDowntimeMessageQuery = gql`
  query downtimeMessage {
    downtimeMessage {
      downtimeMessage
    }
  }
`;
